import { t } from "i18next";
import { enqueueSnackbar } from "notistack";

import { apiClient } from "../../ApiClient";
import { getBackendSignatureMethod } from "../constants";
import { GetState, SetState, Store, StoreData } from "../types";

export const createFileToSign = (set: SetState<StoreData>, get: GetState<Store>) => async () => {
  const integrationId = get().integrationId;
  const environment = get().environment;
  const integration = get().integration;
  const integrationMethod = get().integrationMethod;

  if (integrationId === undefined || environment === undefined || integration === undefined) {
    console.warn("Integration ID, environment or integration is undefined");
    return;
  }

  const backendMethod = getBackendSignatureMethod(integrationMethod);

  try {
    const response = await apiClient.integrations.postIntegrationsIdAuthSignatureCreateFileToSign(
      integrationId,
      {
        environment,
        ...(backendMethod && { method: backendMethod }),
      },
      { format: "blob" }
    );

    const type = response.headers["content-type"];
    const blob = new Blob([response.data], { type: type });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `integracja-ksef-dev-${integration.taxNo}.xml`;
    link.click();
  } catch (error) {
    enqueueSnackbar(t("error.title"));
  }
};
